import { useFeatureFlags } from '@npco/mp-utils-mp-feature-flags'
import { useTranslations } from '@npco/utils-translations'
import { COLOR, Flex, TickIcon } from '@npco/zeller-design-system'

import { savingsAccountBannerTranslations } from '../SavingsAccountBanner.i18n'
import * as styled from '../SavingsAccountBanner.styled'

export const Checklist = () => {
  const t = useTranslations(savingsAccountBannerTranslations)
  const flags = useFeatureFlags()

  const tickColour = flags.SavingsAccountMay ? COLOR.WHITE : COLOR.BLUE_1000
  const textColour = flags.SavingsAccountMay ? '#B5EA39' : COLOR.BLACK

  const point1 = flags.SavingsAccountMay ? t('mayList1') : t('list1')
  const point2 = flags.SavingsAccountMay ? t('mayList2') : t('list2')
  const point3 = flags.SavingsAccountMay ? t('mayList3') : t('list3')

  return (
    <Flex
      gap="8px"
      pb="24px"
      pl="6px"
      flexDirection={{ _: 'column', MD: 'row' }}
      color={textColour}
    >
      <Flex gap="9px">
        <TickIcon color={tickColour} />
        <styled.BannerListItemText>{point1}</styled.BannerListItemText>
      </Flex>
      <Flex gap="9px">
        <TickIcon color={tickColour} />
        <styled.BannerListItemText>{point2}</styled.BannerListItemText>
      </Flex>
      <Flex gap="9px">
        <TickIcon color={tickColour} />
        <styled.BannerListItemText>{point3}</styled.BannerListItemText>
      </Flex>
    </Flex>
  )
}
